import Conversation from "../model/Conversation";

export default class ConversationEndedEvent {
    /**
     * @constructor
     * @param {Conversation} conversation 
     */
    constructor(conversation) {
        this._type = ConversationEndedEvent.TYPE;

        this._conversation = conversation;
    }

    get type() {
        return this._type;
    }

    get conversation() {
        return this._conversation;
    }
}

ConversationEndedEvent.TYPE = "ConversationEndedEvent";